import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './welcome-modal.html';
import '@fabricelements/skeleton-carousel';
import {MySiteRestService} from '@nuskin/my-site-api';
import {nuskin} from '@nuskin/ns-util';
import { MySiteApp } from '../../my-site-app';

/**
 * @customElement
 * @polymer
 */
export class WelcomeModal extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
        this.emailRegex = /.+@.+\.\w+/g;
        this.phoneRegex = /^[^a-zA-Z]*$/;
        this.subdomain = '';
        this.subdomainCheckDebounce = null;
        // this.subdomainIsAvailable = false;
        // this.subdomainIsBlacklisted = false;
        this.formFields = [];

        this.eventsToListenTo = [
            'value-changed',
            'phone-changed',
            'valid-changed',
            'invalid-changed'
        ];
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'welcome-modal';
    }

    ready(){
        super.ready();
        this.getFormFields();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.formChangeHandler.bind(this));
            });
        });
        this.mySite = document.querySelector(MySiteApp.is);
    }

    static get properties() {
        return {
            opsSubdomain: {
                type: String,
                observer: '_handleOpsSubdomain'
            },
            subdomainIsBlacklisted: {
                type: Boolean,
                observer: '_handleError'
            },
            subdomainIsNotAvailable: {
                type: Boolean,
                observer: '_handleError'
            }
        }
    }

    _handleOpsSubdomain(newVal) {
        if(newVal) {
            this.subdomain = newVal;
            this.$.storeUrl.valid = true
        }
    }

    _handleError(error) {
        this.$.successIcon.className = error ? 'hide' : ''
        this.$.errorIcon.className = error ? '' : 'hide'
    }

    validate() {
        this.formIsValid = true;
        this.formFields.forEach(input => {
            input.validate();
            if(!input.valid) this.formIsValid = false;
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.formIds.forEach(id => {
            this.eventsToListenTo.forEach(event => {
                this.$[id].removeEventListener(event, this.formChangeHandler.bind(this));
            });
        });
    }

    formChangeHandler() {
        this.formIsValid = true;
        // check if at least one input is invalid
        this.formFields.forEach(field => {
            if(!field.value && field.required) this.formIsValid = false;
        });

        this.$.continueButton.disabled = !this.formIsValid || this.subdomainIsNotAvailable || this.subdomainIsBlacklisted || this.adjustingStoreUrl;
    }

    async _onContinueClick() {
        this.validate();
        if(this.formIsValid) {
            this.$.continueButton.disabled = true;

            let data = {
                firstName: this.$.firstName.value,
                lastName: this.$.lastName.value,
                displayName: this.$.firstName.value + ' ' + this.$.lastName.value,
                phone: this.$.phone.value,
                email: this.$.email.value
            };

            await MySiteRestService.saveSubdomain(this.subdomain)

            MySiteRestService.initialSponsorSetup(this.subdomain, data, this.$.storeName.value, this.opsSubdomain, null, null, true, this.mySite.content.fullProductCatalogFormShowSearch)
                .then(() => {
                    // GA
                    try {
                        nuskin.events.publish(nuskin.events.mySite.SUCCESSFULL_SETUP, {
                            mySite: {
                                subdomain: this.subdomain
                            }
                        });
                        
                        //page reloaded for intial loading of featureproducts
                        location.replace(location.href) 
                    } catch(err) {console.log(err)}
          
                    this.$.modalContainer.toggle();
                });
        }
    }

    _onSetupShopClick() {
    // important. If we do not set 'activateEvent' to an empty string then any content click(tap)
    // would trigger a 'select' method and would reset carousel back to the first page.
        this.$.modalPages.$.container.activateEvent = '';
        this.$.modalPages.next();
    }

    getStoreUrl(e) {
        this.isModifyingUrl = e.target.id === this.$.storeUrl.id;
        this.isModifyingStoreName = e.target.id !== this.$.storeUrl.id;
        let generatedValue = e.target.value.replace(/[^a-zA-Z0-9]/g,'').toLowerCase();

        if(this.isModifyingStoreName) {
            return this.opsSubdomain || generatedValue.substring(0,50);
        }

        if(this.isModifyingUrl) {
            return generatedValue
        }
    }

    _handleStoreUrl(e) {

        let target = e.target || e.currentTarget;
        if(!target.value) {
            this.subdomainIsBlacklisted = null;
            this.subdomainIsNotAvailable = null;
            this.$.successIcon.className = 'hide';
            this.$.errorIcon.className = 'hide';
        }

        let isModifyingUrl = target.id === this.$.storeUrl.id;
        let isModifyingStoreName = target.id !== this.$.storeUrl.id;
        let generatedValue = target.value.replace(/[^a-zA-Z0-9]/g,'').toLowerCase();
    
        let subdomain = '';

        if(isModifyingStoreName) {
            subdomain = this.opsSubdomain || generatedValue.substring(0,50);
        }

        if(isModifyingUrl) {
            subdomain = generatedValue;
        }

        if(!subdomain) return;

        this.set('subdomain', subdomain);

        this.$.storeUrl.valid = false;
        this.adjustingStoreUrl = true;

        clearTimeout(this.subdomainCheckDebounce);
        // debounce check by 700ms
        this.subdomainCheckDebounce = setTimeout(() => {
            MySiteRestService.isSubdomainBlacklisted(subdomain).then((isBlacklisted) => {
                this.subdomainIsBlacklisted = isBlacklisted;

                if(!this.subdomainIsBlacklisted) {
                    MySiteRestService.isSubdomainAvailable(subdomain).then((isAvailable) => {
                        this.subdomainIsNotAvailable = !isAvailable;

                        if(this.subdomainIsNotAvailable) {
                            this.manipulateStoreUrlFieldValidity(this.content.welcomeStoreUrlAlreadyExist, '@#@#');
                            // GA
                            try {
                                nuskin.events.publish(nuskin.events.mySite.URL_EDIT_ALERTS, {
                                    mySite: {
                                        form: 'welcome modal',
                                        attemptedSubdomain: subdomain,
                                        errorType: 'not available'
                                    }
                                });
                            } catch(err) {console.log(err)}
                        } else {
                            // store url is valid
                            this.manipulateStoreUrlFieldValidity('', '');
                        }
                    });
                } else {
                    this.manipulateStoreUrlFieldValidity(this.content.welcomeStoreUrlBlacklisted, '@#@#')
                    // GA
                    try {
                        nuskin.events.publish(nuskin.events.mySite.URL_EDIT_ALERTS, {
                            mySite: {
                                form: 'welcome modal',
                                attemptedSubdomain: subdomain,
                                errorType: 'blacklisted'
                            }
                        });
                    } catch(err) {console.log(err)}
                }

            });
            this.adjustingStoreUrl = false;
        }, 700);
    }

    manipulateStoreUrlFieldValidity(message, regex) {
        this.$.storeUrl.invalidMessage = message;
        // this regex serves a purpose of invalidating the field when `.validate()` is triggered on storeUrl field.
        // It is done to handle blacklisted/taken sub-domain and prevent form from submitting
        this.$.storeUrl.regexValidation = regex;
        this.$.storeUrl.validate();
        this.$.continueButton.disabled = !this.formIsValid || this.subdomainIsNotAvailable || this.subdomainIsBlacklisted || this.adjustingStoreUrl;
    }

    getFormFields() {
        this.formFields = [
            this.$.firstName,
            this.$.lastName,
            this.$.phone,
            this.$.email,
            this.$.storeName,
            this.$.storeUrl
        ];

    }

}

window.customElements.define(WelcomeModal.is, WelcomeModal);
